import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import { IServiceEditStep, IServiceEditStepData } from '../../../types/index'
import ArrowLeft from '../../icons/entity-icons/ArrowLeft'
import EntityBottomPanel from '../../ui/entity/EntityBottomPanel'
import EntityBottomPanelBoxBtn from '../../ui/entity/EntityBottomPanelBoxBtn'
import EntityBottomPanelBtn from '../../ui/entity/EntityBottomPanelBtn'

interface IServiceCreateBottomBarProps {
  steps: IServiceEditStep[]
  serviceName: string
  currentStep: IServiceEditStepData
  onPreviousClick: (steps: IServiceEditStep[], currentStep: IServiceEditStepData) => void
  onNextClick: () => void
}

const ServiceCreateBottomBar = (props: IServiceCreateBottomBarProps) => {
  const { steps, serviceName, currentStep, onPreviousClick, onNextClick } = props

  const handlePreviousClick = () => {
    onPreviousClick(steps, currentStep)
  }

  const saveButtonName = currentStep.position === steps.length - 1 ? 'Create' : 'Next'

  return (
    <EntityBottomPanel>
      <div className='flex justify-between'>
        {currentStep.position > 0 ? (
          <EntityBottomPanelBoxBtn className='PreviousStep' onClick={handlePreviousClick}>
            <ArrowLeft />
            <span className='ml1 font-blue-grey'>Previous Step</span>
          </EntityBottomPanelBoxBtn>
        ) : (
          <div />
        )}

        <MoonLoader
          sizeUnit={'px'}
          size={27}
          color={'#405264'}
          loading={currentStep.fetching || currentStep.updating}
        />

        {currentStep.position < steps.length && (
          <EntityBottomPanelBtn
            isActive={!currentStep.fetching && !currentStep.updating}
            onClick={onNextClick}
            className='NextStep'
          >
            {saveButtonName}
          </EntityBottomPanelBtn>
        )}
      </div>

      {currentStep.position === steps.length - 1 && steps[currentStep.position].completed && (
        <div className='Status flex justify-center items-center absolute left-0 top-0 right-0 bottom-0 bg-green'>
          <div className='h5 font-white'>New Service {serviceName} successfully created</div>
        </div>
      )}
    </EntityBottomPanel>
  )
}

export default ServiceCreateBottomBar



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceCreateBottomBar.tsx